import request from "@/utils/request";
import store from "@/store";
import _g from "../../src/global";

const AktivitasService = {
  isAllowedIsiAktivitas,
  getAktivitas,
  getValidasiAktivitas,
  simpanAktivitas,
  getKonfigurasiAktivitas,
  simpanKonfigurasiAktivitas,
  searchPegawai,
  searchJabatan
};

function getAktivitas({ from, to }){
  /**
   * @param from string gunakan format yyyy-mm-dd untuk tanggal mulai data diambil
   * @param to string gunakan format yyyy-mm-dd untuk tanggal akhir data diambil
   */
  let current = store.state.user.current;
  let nip = _g.getCurrentUsername();
  let baseUrl = _g.getBaseURLAPIERK(current.year, "v2/aktivitas");

  return request({
      url: baseUrl,
      method: "GET",
      params: { nip, from, to }
  });
}

function getValidasiAktivitas({ from, to }){
  /**
   * aktivitas bawahan yang harus divalidasi oleh pegawai yang sedang login
   * @param from string gunakan format yyyy-mm-dd untuk tanggal mulai data diambil
   * @param to string gunakan format yyyy-mm-dd untuk tanggal akhir data diambil
   */
  let current = store.state.user.current;
  let nip = _g.getCurrentUsername();
  let baseUrl = _g.getBaseURLAPIERK(current.year, "v2/aktivitas/validasi");

  return request({
      url: baseUrl,
      method: "GET",
      params: { nip, from, to }
  });
}

function simpanAktivitas({
  kode_aktivitas,
  kode_kegiatan,
  tanggal,
  volume,
  keterangan,
  sasaran_kinerja_id,
  jam_mulai,
  menit_mulai,
  jam_selesai,
  menit_selesai,
  id_input,
  angka_kredit,
  level
}, jenis){
  let current = store.state.user.current;
  let nip = _g.getCurrentUsername();
  let baseUrl = _g.getBaseURLAPIERK(current.year, "v2/aktivitas");

  let data = {
    "nip": nip,
    "kode_aktivitas": kode_aktivitas,
    "kode_kegiatan": kode_kegiatan,
    "tanggal": tanggal,
    "volume": volume,
    "keterangan": keterangan,
    "sasaran_kinerja_id": sasaran_kinerja_id,
    "jenis": jenis,
    "jam_mulai": jam_mulai,
    "menit_mulai": menit_mulai,
    "jam_selesai": jam_selesai,
    "menit_selesai": menit_selesai,
    "id_input": id_input,
    "angka_kredit": angka_kredit,
    "level": level
  };

  if (jenis == "umum"){
    data["sasaran_kinerja_tambahan_id"] = sasaran_kinerja_id;
  }

  return request({
      url: baseUrl,
      method: "POST",
      data: data
  });
}

function isAllowedIsiAktivitas(){
  let current = store.state.user.current;
  let baseUrl = _g.getBaseURLAPIERK(current.year, `v2/aktivitas/allowed?nip=${current.username}`);

  return request({
      url: baseUrl,
      method: "GET"
  });
}

function getKonfigurasiAktivitas(){
  let current = store.state.user.current;
  let nip = _g.getCurrentUsername();
  let baseUrl = _g.getBaseURLAPIERK(current.year, "v2/konfigurasi-aktivitas");

  return request({
      url: baseUrl,
      method: "GET",
      params: { nip }
  });
}

function simpanKonfigurasiAktivitas(nip_atasan){
  /**
   * @param nip_atasan string NIP pegawai atau id jabatan (PLT) yang menjadi verifikator
   */
  let current = store.state.user.current;
  let nip = _g.getCurrentUsername();
  let baseUrl = _g.getBaseURLAPIERK(current.year, "v2/konfigurasi-aktivitas");

  return request({
      url: baseUrl,
      method: "POST",
      data: { nip, nip_atasan }
  });
}

function searchPegawai(nip){
  let current = store.state.user.current;
  let baseUrl = _g.getBaseURLAPIERK(current.year, `v2/search/${nip}/pegawai`);

  return request({
      url: baseUrl,
      method: "GET"
  });
}

function searchJabatan(id){
  let current = store.state.user.current;
  let baseUrl = _g.getBaseURLAPIERK(current.year, `v2/search/${id}/jabatan`);

  return request({
      url: baseUrl,
      method: "GET"
  });
}

export default AktivitasService;
